export const cookieFallbackTitle = "mjk33d";
export const cookieFallbackDescription = "KR4X1b";
export const errorFallbackTitle = "_xCqIc";
export const errorFallbackDescription = "un3nRe";
export const goToRewardsButton = "L153Se";
export default {cookieFallbackTitle,cookieFallbackDescription,errorFallbackTitle,errorFallbackDescription,goToRewardsButton};